
import { useTranslation } from 'react-i18next';

export default function HomePage() {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen bg-[#F9F7EA]">
      {/* Navigation */}
      <nav className="bg-[#3D5639] shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <div className="text-[#F2E6AF] text-4xl font-bold" style={{ fontFamily: 'Great Vibes, cursive' }}>
                Rosmarino
              </div>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="bg-[#51674C] text-[#F9F7EA] px-4 py-3 rounded-md text-base font-medium tracking-wide">
                  Home
                </a>
                <a href="/menu" className="text-[#F9F7EA] hover:text-[#F2E6AF] px-4 py-3 rounded-md text-base font-medium transition-colors tracking-wide">
                  Menu
                </a>
                <a href="/prenotazioni" className="text-[#F9F7EA] hover=text-[#F2E6AF] px-4 py-3 rounded-md text-base font-medium transition-colors tracking-wide">
                  Prenotazioni
                </a>
                <a href="#contatti" className="text-[#F9F7EA] hover:text-[#F2E6AF] px-4 py-3 rounded-md text-base font-medium transition-colors tracking-wide">
                  Contatti
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative h-screen flex items-center justify-center bg-cover bg-center bg-[#F9F7EA]" 
               style={{ backgroundImage: `linear-gradient(rgba(61, 86, 57, 0.7), rgba(61, 86, 57, 0.7)), url('https://static.readdy.ai/image/8db0a309f4e529fd4405705b10cd8ce9/f06fa60e869888523a74143711150ef2.jpeg')` }}>
        <div className="text-center text-[#FEFEFE] max-w-4xl px-6">
          <h1 className="text-6xl md:text-8xl mb-6" style={{ fontFamily: 'Great Vibes, cursive' }}>
            Benvenuti a Rosmarino
          </h1>
          <p className="text-2xl md:text-3xl mb-8 text-[#F2E6AF]" style={{ fontFamily: 'Great Vibes, cursive' }}>
            Dove il gusto diventa poesia
          </p>
          <div className="text-center">
            <a 
              href="/prenotazioni"
              className="inline-block bg-[#F2E6AF] text-[#3D5639] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#F9F7EA] transition-colors whitespace-nowrap"
            >
              Prenota Ora
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gradient-to-br from-[#F9F7EA] via-[#FEFEFE] to-[#F2E6AF]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Decorative Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#3D5639] rounded-full mb-6">
              <i className="ri-leaf-line text-3xl text-[#F2E6AF]"></i>
            </div>
            <h2 className="text-6xl text-[#3D5639] mb-6" style={{ fontFamily: 'Great Vibes, cursive' }}>
              Chi Siamo
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-[#3D5639] to-[#51674C] mx-auto mb-4"></div>
            <p className="text-xl text-[#51674C] max-w-3xl mx-auto leading-relaxed">
              Una storia di passione che nasce da più di 20 anni di amore per l'autenticità delle tradizioni romane
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Story Content */}
            <div className="relative">
              {/* Decorative Background Element */}
              <div className="absolute -top-8 -left-8 w-32 h-32 bg-[#F2E6AF]/30 rounded-full blur-xl"></div>
              <div className="absolute -bottom-8 -right-8 w-24 h-24 bg-[#3D5639]/20 rounded-full blur-lg"></div>
              
              <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-[#F2E6AF]/50">
                <div className="mb-8">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-1 bg-[#3D5639] mr-4"></div>
                    <h3 className="text-2xl font-bold text-[#3D5639]" style={{ fontFamily: 'Alex Brush, cursive' }}>
                      Dove il gusto diventa poesia
                    </h3>
                  </div>
                  
                  <div className="space-y-6 text-[#51674C] leading-relaxed">
                    <p className="text-lg">
                      Una storia di passione, nasce da più di 20 anni, in un viaggio nel cuore dei Castelli Romani da un'amore e passione per l'autenticità delle tradizioni locali della magica cucina romana.
                    </p>
                    
                    <div className="bg-[#F9F7EA] rounded-lg p-6 border-l-4 border-[#3D5639]">
                      <p className="text-base italic">
                        "Nasce un'ammirazione camminando negli stretti vicoli della città, sentendo i dolci odori che passano da una finestra all'altra, passeggiando davanti ai forni... ti attira l'odore della panificazione del grano cotto alla legna."
                      </p>
                    </div>
                    
                    <p className="text-lg">
                      Questi odori che ti fanno sentire a casa attirandoti l'anima senza sentirlo. La storia del Rosmarino nasce da questo inaspettato viaggio creando da un'amore per le tradizioni romane un immenso e lungo studio dei grandi maestri della cucina antica.
                    </p>
                    
                    <p className="text-lg">
                      Evoluendo i veri metodi e modi di fare per i deliziosi piatti, impasti per pizze locali e pane artigianale, creando una miscela tra la storia, lo studio gastronomico e la cucina moderna.
                    </p>
                  </div>
                </div>

                {/* Contact Information */}
                <div className="bg-gradient-to-r from-[#3D5639] to-[#51674C] rounded-xl p-6 text-white mb-8">
                  <div className="flex items-center mb-4">
                    <i className="ri-phone-line text-2xl text-[#F2E6AF] mr-3"></i>
                    <h4 className="text-xl font-semibold">Contattaci</h4>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <i className="ri-map-pin-line text-[#F2E6AF] mr-2"></i>
                        <span className="font-medium">Ciampino</span>
                      </div>
                      <p className="text-sm text-white/90 mb-2">Piazza Trento e Trieste 3</p>
                      <p className="text-sm text-[#F2E6AF]">📞 06 45763624</p>
                    </div>
                    
                    <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <i className="ri-map-pin-line text-[#F2E6AF] mr-2"></i>
                        <span className="font-medium">Ariccia</span>
                      </div>
                      <p className="text-sm text-white/90 mb-2">Viale Antonietta Chigi 16</p>
                      <p className="text-sm text-[#F2E6AF]">📞 06 45769762</p>
                    </div>
                  </div>
                  
                  <div className="mt-4 text-center">
                    <a 
                      href="https://wa.me/393480846132?text=Ciao! Vorrei prenotare un tavolo presso il Ristorante Rosmarino. Potreste aiutarmi con la prenotazione?"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center bg-[#25D366] text-white px-6 py-3 rounded-lg hover:bg-[#128C7E] transition-colors font-medium whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-fill mr-2 text-lg"></i>
                      Prenota su WhatsApp
                    </a>
                  </div>
                </div>

                {/* Artistic Stats */}
                <div className="grid grid-cols-3 gap-6">
                  <div className="text-center relative">
                    <div className="bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-3 shadow-lg">
                      <span className="text-2xl font-bold text-[#F2E6AF]">20+</span>
                    </div>
                    <div className="text-sm font-medium text-[#3D5639]">Anni di Esperienza</div>
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-[#F2E6AF] rounded-full opacity-60"></div>
                  </div>
                  
                  <div className="text-center relative">
                    <div className="bg-gradient-to-br from-[#51674C] to-[#3D5639] rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-3 shadow-lg">
                      <span className="text-2xl font-bold text-[#F2E6AF]">50K+</span>
                    </div>
                    <div className="text-sm font-medium text-[#3D5639]">Clienti Soddisfatti</div>
                    <div className="absolute -top-2 -left-2 w-4 h-4 bg-[#F2E6AF] rounded-full opacity-80"></div>
                  </div>
                  
                  <div className="text-center relative">
                    <div className="bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-3 shadow-lg">
                      <span className="text-2xl font-bold text-[#F2E6AF]">200+</span>
                    </div>
                    <div className="text-sm font-medium text-[#3D5639]">Ricette Tradizionali</div>
                    <div className="absolute -bottom-2 -right-2 w-5 h-5 bg-[#F2E6AF] rounded-full opacity-70"></div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Image Section */}
            <div className="relative">
              {/* Artistic Frame */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#3D5639] to-[#51674C] rounded-3xl transform rotate-3 scale-105 opacity-20"></div>
              <div className="absolute inset-0 bg-gradient-to-tl from-[#F2E6AF] to-[#F9F7EA] rounded-3xl transform -rotate-2 scale-102 opacity-30"></div>
              
              <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                <img 
                  src="https://static.readdy.ai/image/8db0a309f4e529fd4405705b10cd8ce9/f72c1755a40d999248eeaadc1f031899.jpeg"
                  alt="La nostra storia - Rosmarino"
                  className="w-full h-96 object-cover object-center transform hover:scale-105 transition-transform duration-700"
                />
                
                {/* Overlay with Quote */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#3D5639]/90 to-transparent p-6">
                  <div className="text-[#F2E6AF] text-center">
                    <i className="ri-double-quotes-l text-2xl mb-2 block"></i>
                    <p className="text-lg font-medium" style={{ fontFamily: 'Alex Brush, cursive' }}>
                      Dove ogni piatto racconta una storia
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-[#F2E6AF] rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-restaurant-line text-2xl text-[#3D5639]"></i>
              </div>
              <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-[#3D5639] rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-heart-fill text-lg text-[#F2E6AF]"></i>
              </div>
            </div>
          </div>

          {/* Bottom Decorative Section */}
          <div className="mt-20 text-center">
            <div className="inline-flex items-center space-x-4 bg-white/60 backdrop-blur-sm rounded-full px-8 py-4 shadow-lg border border-[#F2E6AF]/50">
              <div className="w-3 h-3 bg-[#3D5639] rounded-full animate-pulse"></div>
              <span className="text-[#51674C] font-medium">Tradizione</span>
              <div className="w-3 h-3 bg-[#51674C] rounded-full animate-pulse delay-300"></div>
              <span className="text-[#51674C] font-medium">Passione</span>
              <div className="w-3 h-3 bg-[#F2E6AF] rounded-full animate-pulse delay-700"></div>
              <span className="text-[#51674C] font-medium">Autenticità</span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contatti" className="py-20 bg-[#FEFEFE]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl text-[#3D5639] mb-4" style={{ fontFamily: 'Alex Brush, cursive' }}>
              Vieni a Trovarci
            </h2>
            <p className="text-lg text-[#51674C]">
              Vivi l'autentica ospitalità italiana
            </p>
          </div>

          {/* WhatsApp Reservation Section */}
          <div className="mb-16">
            <div className="bg-gradient-to-r from-[#25D366] to-[#128C7E] rounded-2xl p-8 text-white shadow-xl">
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
                  <i className="ri-whatsapp-line text-3xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Alex Brush, cursive' }}>
                  Prenota Velocemente su WhatsApp
                </h3>
                <p className="text-lg text-white/90">
                  Contattaci direttamente per prenotazioni immediate e informazioni
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {/* Ciampino WhatsApp */}
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <div className="flex items-center mb-4">
                    <i className="ri-map-pin-line text-2xl text-white mr-3"></i>
                    <h4 className="text-xl font-semibold">Ciampino - Sede Storica</h4>
                  </div>
                  <p className="text-white/90 mb-4">
                    Piazza Trento e Trieste 3<br />
                    00043 Ciampino (RM)
                  </p>
                  <a 
                    href="https://wa.me/393480846132?text=Ciao! Vorrei prenotare un tavolo presso la sede di CIAMPINO del Ristorante Rosmarino in Piazza Trento e Trieste 3. Potreste aiutarmi con la prenotazione?"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center w-full bg-white text-[#25D366] px-6 py-3 rounded-lg font-semibold hover:bg-white/90 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-fill mr-2 text-xl"></i>
                    Prenota su WhatsApp
                  </a>
                  <p className="text-sm text-white/80 mt-2 text-center">
                    +39 348 084 6132
                  </p>
                </div>

                {/* Ariccia WhatsApp */}
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <div className="flex items-center mb-4">
                    <i className="ri-map-pin-line text-2xl text-white mr-3"></i>
                    <h4 className="text-xl font-semibold">Ariccia - Nuova Sede</h4>
                  </div>
                  <p className="text-white/90 mb-4">
                    Viale Antonietta Chigi 16<br />
                    00072 Ariccia (RM)
                  </p>
                  <a 
                    href="https://wa.me/393480846132?text=Ciao! Vorrei prenotare un tavolo presso la sede di ARICCIA del Ristorante Rosmarino in Viale Antonietta Chigi 16. Potreste aiutarmi con la prenotazione?"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center w-full bg-white text-[#25D366] px-6 py-3 rounded-lg font-semibold hover:bg-white/90 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-fill mr-2 text-xl"></i>
                    Prenota su WhatsApp
                  </a>
                  <p className="text-sm text-white/80 mt-2 text-center">
                    +39 348 084 6132
                  </p>
                </div>
              </div>

              <div className="text-center mt-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 inline-block">
                  <p className="text-sm text-white/90">
                    <i className="ri-time-line mr-2"></i>
                    Rispondiamo su WhatsApp durante gli orari di apertura
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            <div className="space-y-8">
              {/* Ciampino Location - Sede Storica */}
              <div className="bg-[#F9F7EA] p-6 rounded-lg shadow-lg">
                <div className="flex items-center mb-4">
                  <i className="ri-map-pin-line text-2xl text-[#3D5639] mr-3"></i>
                  <h3 className="text-xl font-semibold text-[#3D5639]">Ciampino - Sede Storica</h3>
                </div>
                <p className="text-[#51674C] mb-2">
                  Piazza Trento e Trieste 3<br />
                  00043 Ciampino (RM)
                </p>
                <div className="flex items-center mt-3 mb-3">
                  <i className="ri-phone-line text-lg text-[#3D5639] mr-2"></i>
                  <span className="text-[#51674C]">06 45763624</span>
                </div>
                <div className="flex items-start mt-3">
                  <i className="ri-time-line text-lg text-[#3D5639] mr-2 mt-1"></i>
                  <div className="text-[#51674C]">
                    <p className="font-medium">Chiuso Lunedì</p>
                    <p>Mar-Gio: 15:30-00:00</p>
                    <p>Ven-Dom: 11:00-00:00</p>
                  </div>
                </div>
              </div>

              {/* Ariccia Location - Nuova Sede */}
              <div className="bg-[#F9F7EA] p-6 rounded-lg shadow-lg">
                <div className="flex items-center mb-4">
                  <i className="ri-map-pin-line text-2xl text-[#3D5639] mr-3"></i>
                  <h3 className="text-xl font-semibold text-[#3D5639]">Ariccia - Nuova Sede</h3>
                </div>
                <p className="text-[#51674C] mb-2">
                  Viale Antonietta Chigi 16<br />
                  00072 Ariccia (RM)
                </p>
                <div className="flex items-center mt-3 mb-3">
                  <i className="ri-phone-line text-lg text-[#3D5639] mr-2"></i>
                  <span className="text-[#51674C]">06 45769762</span>
                </div>
                <div className="flex items-start mt-3">
                  <i className="ri-time-line text-lg text-[#3D5639] mr-2 mt-1"></i>
                  <div className="text-[#51674C]">
                    <p className="font-medium">Chiuso Lunedì</p>
                    <p>Mar-Dom: 11:00-00:00</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#FEFEFE] rounded-lg shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.0!2d12.6644!3d41.7284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDQzJzQyLjIiTiAxMsKwMzknNTEuOCJF!5e0!3m2!1sit!2sit!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Rosmarino Restaurant Locations"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#3D5639] text-[#F9F7EA] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="mb-4">
                <div className="text-[#F2E6AF] text-2xl font-bold" style={{ fontFamily: 'Great Vibes, cursive' }}>
                  Rosmarino
                </div>
              </div>
              <p className="text-[#F9F7EA] mb-4">
                Autentica cucina italiana fatta con amore e tradizione.
              </p>
              <div className="flex space-x-4">
                <i className="ri-facebook-fill text-xl hover:text-[#F2E6AF] cursor-pointer"></i>
                <i className="ri-instagram-line text-xl hover:text-[#F2E6AF] cursor-pointer"></i>
                <i className="ri-twitter-line text-xl hover:text-[#F2E6AF] cursor-pointer"></i>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-[#F2E6AF] mb-4">Link Rapidi</h4>
              <ul className="space-y-2">
                <li><a href="#home" className="hover:text-[#F2E6AF] cursor-pointer">Home</a></li>
                <li><a href="/menu" className="hover:text-[#F2E6AF] cursor-pointer">Menu</a></li>
                <li><a href="#about" className="hover:text-[#F2E6AF] cursor-pointer">Chi Siamo</a></li>
                <li><a href="#contact" className="hover=text-[#F2E6AF] cursor-pointer">Contatti</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-[#F2E6AF] mb-4">Le Nostre Sedi</h4>
              <div className="space-y-3">
                <div>
                  <p className="font-medium text-[#F2E6AF]">Ciampino - Sede Storica</p>
                  <p className="text-sm">Piazza Trento e Trieste 3</p>
                  <p className="text-sm">Tel: 06 45763624</p>
                </div>
                <div>
                  <p className="font-medium text-[#F2E6AF]">Ariccia - Nuova Sede</p>
                  <p className="text-sm">Viale Antonietta Chigi 16</p>
                  <p className="text-sm">Tel: 06 45769762</p>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-[#F2E6AF] mb-4">Newsletter</h4>
              <p className="text-sm mb-4">Iscriviti per offerte speciali e aggiornamenti</p>
              <div className="flex">
                <input
                  type="email"
                  placeholder="La tua email"
                  className="flex-1 px-4 py-2 rounded-l-full text-[#3D5639] text-sm"
                />
                <button className="bg-[#51674C] px-6 py-2 rounded-r-full hover:bg-[#F2E6AF] hover:text-[#3D5639] transition-colors whitespace-nowrap cursor-pointer">
                  Iscriviti
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-[#51674C] mt-12 pt-8 text-center">
            <p>&copy; 2024 Ristorante Rosmarino. Tutti i diritti riservati. | <a href="https://readdy.ai/?origin=logo" className="hover:text-[#F2E6AF] cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
